/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import CryptoJS from 'crypto-js'
import CryptoENC from 'crypto-js/enc-utf8';

const dates = {
    convert: function (d) {
        // Converts the date in d to a date-object. The input can be:
        //   a date object: returned without modification
        //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
        //   a number     : Interpreted as number of milliseconds
        //                  since 1 Jan 1970 (a timestamp) 
        //   a string     : Any format supported by the javascript engine, like
        //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
        //  an object     : Interpreted as an object with year, month and date
        //                  attributes.  **NOTE** month is 0-11.
        return (
            d.constructor === Date ? d :
                d.constructor === Array ? new Date(d[0], d[1], d[2]) :
                    d.constructor === Number ? new Date(d) :
                        d.constructor === String ? new Date(d) :
                            typeof d === "object" ? new Date(d.year, d.month, d.date) :
                                NaN
        );
    },
    compare: function (a, b) {
        // Compare two dates (could be of any type supported by the convert
        // function above) and returns:
        //  -1 : if a < b
        //   0 : if a = b
        //   1 : if a > b
        // NaN : if a or b is an illegal date
        // NOTE: The code inside isFinite does an assignment (=).
        return (
            isFinite(a = this.convert(a).valueOf()) &&
                isFinite(b = this.convert(b).valueOf()) ?
                (a > b) - (a < b) :
                NaN
        );
    },
    inRange: function (d, start, end) {
        // Checks if date in d is between dates in start and end.
        // Returns a boolean or NaN:
        //    true  : if d is between start and end (inclusive)
        //    false : if d is before start or after end
        //    NaN   : if one or more of the dates is illegal.
        // NOTE: The code inside isFinite does an assignment (=).
        return (
            isFinite(d = this.convert(d).valueOf()) &&
                isFinite(start = this.convert(start).valueOf()) &&
                isFinite(end = this.convert(end).valueOf()) ?
                start <= d && d <= end :
                NaN
        );
    },

    addDays: function (date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }
}
export default class Crypt {
    constructor() {
        this.key = '1234abcd0998ijdf';
        
       
    }

    encrypt(a) {
        return CryptoJS.AES.encrypt(a, this.key, {}).toString();
    }

    decrypt(a) {
        return CryptoJS.AES.decrypt(a.toString(), this.key, {}).toString(CryptoJS.enc.Utf8);
    }

    encryptJson(a) {
        try {
            if (typeof a === 'object') {
                let string = JSON.stringify(a);
                return CryptoJS.AES.encrypt(string, this.key, {}).toString();
            }
            return '';

        } catch {
            return '';
        }
    }

    parseJwt (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
    };

    isValidToken(b){

        let a = new Date();
        b = new Date(b * 1000);
        let e = dates.compare(a,b) == -1;
      /*   console.log('valid',e); */
      // O TOKEN DO SISTEMA TÁ VOLTANDO EXP DATE ERRADA
        return e;
    }

    decryptJson(a) {
        try {
            if (typeof a === 'string') {
                let bytes = CryptoJS.AES.decrypt(a, this.key);
                let json = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                return json;
            }
            return '';

        } catch {
            return '';
        }
    }
}